<template>
    <div class="lottery-page" style="
        background-size: cover; 
        background: #12101C;
        padding-bottom: 7rem;
    ">
        <div class="d-flex flex-wrap pt-3">
            <!-- <div class="col-12">
                <div class="mx-0 card d-flex justify-content-between col-12 flex-row py-4">
                    <div class="col-4 d-flex flex-column">
                        <i class="fa-solid fa-file mx-auto"></i>
                        <span class="text-center mt-2">Records</span>
                    </div>
                    <div class="col-4 d-flex flex-column">
                        <i class="fa fa-calendar mx-auto"></i>
                        <span class="text-center mt-2">Closed Days</span>
                    </div>
                    <div class="col-4 d-flex flex-column">
                        <i class="fa-solid fa-list mx-auto"></i>
                        <span class="text-center mt-2">Winners List</span>
                    </div>
                </div>
            </div> -->


            <div class="col-12 mx-auto d-flex" style="padding-left: 10px; padding-right: 10px;">
                <div class="mx-0 d-flex justify-content-between col-12 flex-row px-0 mb-0">
                    <div class="col-3 d-flex flex-column" style="border-radius: 10px; box-shadow: 0 0 3px #E76229; cursor: pointer; padding: 10px 5px; text-align: center;" @click="$router.push({ path: '/betslip-history', query: { type: 'twod' } })">
                        <img
                            src="https://storage.googleapis.com/spacetech2/shweohhh/edit%20(1).png"
                            alt=""
                            class="mx-auto"
                            style="width: 2rem; height: auto"
                            />
                        <span class="text-center mt-2">Records</span>
                    </div>
                    <div class="col-3 d-flex flex-column" style="border-radius: 10px; box-shadow: 0 0 3px #E76229; cursor: pointer; padding: 10px 5px; text-align: center;" @click="$router.push('/user/2d/winner')">
                        <img
                            src="https://storage.googleapis.com/spacetech2/shweohhh/win%20(1).png"
                            alt=""
                            class="mx-auto"
                            style="width: 2rem; height: auto"
                            />
                        <span class="text-center mt-2">Winners List</span>
                    </div>
                    <div class="col-3 d-flex flex-column" style="border-radius: 10px; box-shadow: 0 0 3px #E76229; cursor: pointer; padding: 10px 5px; text-align: center;" @click="$router.push('/user/2d/closed')">
                        <img
                            src="https://storage.googleapis.com/spacetech2/shweohhh/calendar%20(1).png"
                            alt=""
                            class="mx-auto"
                            style="width: 2rem; height: auto"
                            />
                        <span class="text-center mt-2">Closed Days</span>
                    </div>
                </div>
            </div>
            
            <div class="col-12 home-cards live-card" style="margin-top: 10px;">
                <div class="twod-threed-cards">
                    <!-- <div class="card-header" v-if="isLive">
                        <div v-if="$store.state.language === 'en'">
                            2D live Result
                        </div>
                        <div v-else><h3>နှစ်လုံး တိုက်ရိုက်ရလဒ်</h3></div>
                        <div>
                            <b-spinner variant="secondary"></b-spinner>
                        </div>
                    </div> -->
                    <div class="card-body d-flex" v-if="isLive">
                        <div class="my-auto col-12">
                            <div class="text-center card">
                                <span class="live-result">{{
                                        twoDdata.live
                                    }}</span>
                            </div>
                            <div class="live-set-val-container d-flex col-12 p-0">
                                <div class="col-6 p-0">
                                    <small class="text-white">
                                        Set &nbsp;- &nbsp;
                                        <span class="live-number">{{
                                            twoDdata.live_set
                                        }}</span></small
                                    >
                                </div>
                                <div class="col-6 p-0">
                                    <small class="text-white"
                                        >Value &nbsp;- &nbsp;
                                        <span class="live-number">{{
                                            twoDdata.live_val
                                        }}</span></small
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex" v-if="!isLive">
                        <div
                            class="
                                my-auto
                                mx-auto
                                not-live-text
                                d-flex
                                flex-wrap
                                w-100
                                p-3
                                h-100
                            "
                        >
                            <div
                                class="w-100 d-flex"
                                style="
                                    font-size: 80px;
                                "
                            >
                                <div
                                    class="my-auto mx-auto"
                                    v-if="twoDHistories.length > 0"
                                >
                                    {{ lastNumber }}
                                </div>
                            </div>
                            <div class="d-flex w-100">
                                <div
                                    class="my-auto mx-auto"
                                    style="font-size: 1.2rem; font-weight: 400;"
                                >
                                <img src="https://storage.googleapis.com/spacetech2/shweohhh/check.png" class="mb-1" style="width: 1.5rem; height: 1.5rem;" alt="">
                                    <span>
                                        {{
                                            $store.state.language === "en"
                                                ? "Updated : "
                                                : "အပ်ဒိတ် : "
                                        }}</span
                                    >
                                    <span>{{ lastUpdatedDate }}</span>
                                    <span> {{ lastUpdatedDraw }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        
            <div class="col-12" style="padding-left: 10px; padding-right: 10px;">
                <table>
                    <thead>
                        <tr>
                            <th >နေ့စွဲ</th>
                            <th >မနက် - 12:01</th>
                            <th >ညနေ - 04:30</th>
                            <!-- <th>Won Amount</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(twodHistory, index) in twoDHistories" :key="index">
                            <td>{{ twodHistory.draw_date }}</td>
                            <td>{{ twodHistory.morning_result }}</td>
                            <td>{{ twodHistory.evening_result }}</td>
                            <!-- <td>{{Number(user.won).toLocaleString()}} MMK</td> -->
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="bet-container">
                <button class="btn custom-btn text-nowrap" @click="toGoToTwodPage()">
                    <!-- <h3 class="text-uppercase" style="color: black"> -->
                        {{
                            $store.state.language === "en"
                                ? "BET"
                                : "ထိုးမည်"
                        }}    
                    <!-- </h3> -->
                </button>
            </div>

            <div
                class="modal fade"
                id="timeLimitModal"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-form"
                aria-hidden="true"
            >
                <div
                    class="modal-dialog modal-dialog-centered"
                    role="document"
                >
                    <div class="modal-content">
                        <div class="modal-body my-5 mx-3 text-center d-flex flex-column">
                            <div
                                v-if="myanmarTimeDisplay"
                                class="col-12 mb-3"
                            >
                                <span style="color: #E76229">{{
                                    $store.state.language === "en"
                                        ? "Myanmar time (Yangon): "
                                        : "မြန်မာစံတော်ချိန် (ရန်ကုန်) - "
                                }}</span>
                                <strong style="color: #E76229; font-size: 1.35rem; letter-spacing: 0.05em">{{ myanmarTimeDisplay }}</strong>
                            </div>
                            <button
                                type="button"
                                class="col-12 p-0 pl-1 py-1 border-0 bg-transparent"
                                v-for="(option, index) in twodOptions"
                                :key="index"
                                v-show="!noticeText"
                                @click="selectDraw(option.data)"
                            >
                                <div
                                    class="time-cont text-dark py-2 text-center w-100"
                                    :class="draw === option.data ? 'active' : ''"
                                >
                                    {{ option.label }}
                                </div>
                            </button>
                            <div class="col-12 p-0 pl-1 py-1" v-if="noticeText">
                                <div class="time-cont text-dark py-2 text-center w-100">
                                    {{ noticeText }}
                                </div>
                            </div>

                            <div class="col-12 mt-2">
                                <button
                                    type="button"
                                    class="btn custom-btn py-3 text-nowrap"
                                    :disabled="!draw"
                                    @click="toGoToTwodPage(draw)"
                                >
                                    {{
                                        $store.state.language === "en"
                                            ? "BET"
                                            : "ထိုးမည်"
                                    }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import createDateWithTimeZone from "../../../../libs/createDateWithTimeZone"
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      twoDdata: {},
      isLive: false,
      twoDHistories: {},
      internetModern: [],
      interval: null,
      threedData: {},
      twodOptions: [],
      draw: null,
    noticeText: null,
      interval: null,
      myanmarTimeDisplay: null,
      myanmarTimeIntervalId: null,
    };
  },
  computed: {
    lastNumber() {
      return (
        this.twoDHistories[0]?.evening_result
                || this.twoDHistories[0]?.mid_evening_result || this.twoDHistories[0]?.morning_result || this.twoDHistories[0]?.mid_morning_result
      );
    },
    lastUpdatedDraw() {
      if (
        this.twoDHistories.length > 0
                && this.twoDHistories[0]?.evening_result
      ) return '4:30 PM';
      if (
        this.twoDHistories.length > 0
                && this.twoDHistories[0]?.mid_evening_result
      ) return '2:45 PM';
      if (
        this.twoDHistories.length > 0
                && this.twoDHistories[0]?.morning_result
      ) return '12:01 AM';
      return '10:45 AM';
    },
    lastUpdatedDate() {
      return this.twoDHistories[0]?.draw_date;
    },
  },
  methods: {
    ...mapActions(['fetchUser']),
    selectDraw(data) {
      this.draw = data;
      this.noticeText = null;
    },
    hideTimeLimitModalOverlay() {
      const $modal = $('#timeLimitModal');
      $modal.modal('hide');
      $modal.removeClass('show').css('display', 'none');
      // Hide finishes async; removing the node mid-animation leaves a full-page
      // .modal-backdrop that blocks clicks on /user/2d.
      $('.modal-backdrop').remove();
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('padding-right');
    },
    cleanupTimeLimitModal() {
      const $modal = $('#timeLimitModal');
      if (this._onTimeLimitModalShown) {
        $modal.off('shown.bs.modal', this._onTimeLimitModalShown);
        this._onTimeLimitModalShown = null;
      }
      if (this._onTimeLimitModalHidden) {
        $modal.off('hidden.bs.modal', this._onTimeLimitModalHidden);
        this._onTimeLimitModalHidden = null;
      }
      this.hideTimeLimitModalOverlay();
      this.stopMyanmarTimeClock();
      const el = $modal[0];
      // Return the node to this component so Vue can unmount it cleanly
      if (el && el.parentNode === document.body && this.$el) {
        this.$el.appendChild(el);
      }
    },
    toGoToTwodPage(draw) {
        if (draw) {
            this.cleanupTimeLimitModal();
            this.$router.push(`/user/2d?draw=${draw}`);
        } else {
            this.drawOptionGenerator().finally(() => {
              const $modal = $('#timeLimitModal');
              // Escape app shell overflow so draw times remain clickable on PC
              if ($modal.length && $modal.parent()[0] !== document.body) {
                $modal.appendTo(document.body);
              }
              $modal.modal('show');
            });
        }
    },
    tickMyanmarTimeClock() {
      this.myanmarTimeDisplay = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Asia/Yangon',
        weekday: 'short',
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      }).format(new Date());
    },
    startMyanmarTimeClock() {
      this.stopMyanmarTimeClock();
      this.tickMyanmarTimeClock();
      this.myanmarTimeIntervalId = setInterval(() => this.tickMyanmarTimeClock(), 1000);
    },
    stopMyanmarTimeClock() {
      if (this.myanmarTimeIntervalId != null) {
        clearInterval(this.myanmarTimeIntervalId);
        this.myanmarTimeIntervalId = null;
      }
      this.myanmarTimeDisplay = null;
    },
    threedDrawDateFormat(date) {
      return moment(date).format('ll');
    },
    yangonClockMinutes(date) {
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Asia/Yangon',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }).formatToParts(date || new Date());
      const hourRaw = parseInt(parts.find((p) => p.type === 'hour').value, 10);
      const minute = parseInt(parts.find((p) => p.type === 'minute').value, 10);
      const hour = hourRaw === 24 ? 0 : hourRaw;
      return hour * 60 + minute;
    },
    parseBetTimeToMinutes(timeStr, isEvening) {
      const [h, m] = String(timeStr || '').split(':').map((v) => parseInt(v, 10));
      let hour = Number.isFinite(h) ? h : (isEvening ? 16 : 12);
      const minute = Number.isFinite(m) ? m : (isEvening ? 0 : 1);
      if (isEvening && hour < 12) hour += 12;
      return hour * 60 + minute;
    },
    async drawOptionGenerator() {
      try {
        let nowMins = this.yangonClockMinutes();
        try {
          const apiNow = await createDateWithTimeZone();
          if (apiNow && !Number.isNaN(apiNow.getTime())) {
            nowMins = this.yangonClockMinutes(apiNow);
          }
        } catch (e) {
          // keep Intl Asia/Yangon fallback
        }

        // Show 12:01 PM until the morning draw (Yangon), same as BuffaloBoss.
        const morningCloseMins = this.parseBetTimeToMinutes('12:01', false);
        const latest_bet_e = this.twoDdata && this.twoDdata.latest_bet_e
          ? String(this.twoDdata.latest_bet_e)
          : '16:00';
        const eveningCloseMins = this.parseBetTimeToMinutes(latest_bet_e, true);

        this.noticeText = null;

        if (nowMins < morningCloseMins) {
          this.twodOptions = [
            { data: 'm', label: '12:01 PM' },
            { data: 'f', label: '4:30 PM' },
          ];
          if (!this.draw) this.draw = 'm';
        } else if (nowMins < eveningCloseMins) {
          this.twodOptions = [
            { data: 'f', label: '4:30 PM' },
          ];
          this.draw = 'f';
        } else {
          this.twodOptions = [];
          this.draw = null;
          this.noticeText = this.$store.state.language === 'en'
            ? '2D is closed for Today.'
            : 'ယနေ့အတွက် နှစ်လုံးထီ ထိုးခြင်း ပိတ်ပါပြီ ။';
        }
      } catch (error) {
        console.error('drawOptionGenerator', error);
        this.noticeText = null;
        this.twodOptions = [
          { data: 'm', label: '12:01 PM' },
          { data: 'f', label: '4:30 PM' },
        ];
      }
    },
    async fetchTwoDliveresult() {
        const apiUrl = 'https://luke.2dboss.com/api/luke/twod-result-live';

        // Make a GET request using the fetch function
        fetch(apiUrl)
            .then(response => {
            // Check if the request was successful (status code 2xx)
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON response
            return response.json();
            })
            .then(data => {
            this.twoDdata = data.data || {}
            })
            .catch(error => {
            // Handle errors
            console.error('Error fetching data:', error);
            });
        // },
    },
    async fetchModernInternet() {
      try {
        const res = await axios.get('/modern-internet');
        this.internetModern = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchTwoDdata() {
      try {
        const res = await axios.get('/2d/data');
        this.isLive = res.data.data[0].isLive;
        this.twoDdata = res.data.data[0];
        if (this.isLive) {
            this.fetchTwoDliveresult();
            this.interval = setInterval(() => this.fetchTwoDliveresult(), 5000);
        }
      } catch (error) {
        console.log(error);
      }
    },
    ready() {
    //   const channel = this.$pusher.subscribe('live-socket-channel');
    //   channel.bind('twod-live', async (data) => {
    //     this.twoDdata = data;
    //   });

      //   channel.bind('twod-isLive', async (data) => {
      //     this.isLive = data;
      //   });
    },

    async fetchTwoThreeDHistories() {
      try {
        const twoDres = await axios.get('/twod_history');
        this.twoDHistories = twoDres.data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
    this.cleanupTimeLimitModal();
  },
  destroyed() {
    clearInterval(this.interval);
    this.hideTimeLimitModalOverlay();
  },
  unmount() {
    clearInterval(this.interval);
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }

    await this.fetchTwoDdata();
    await this.fetchTwoThreeDHistories();
    await this.drawOptionGenerator();
    this.interval = setInterval(async () => await this.drawOptionGenerator(), 30000);

    const modal = $('#timeLimitModal');
    this._onTimeLimitModalShown = () => {
      this.startMyanmarTimeClock();
      this.drawOptionGenerator();
    };
    this._onTimeLimitModalHidden = () => {
      this.stopMyanmarTimeClock();
    };
    modal.on('shown.bs.modal', this._onTimeLimitModalShown);
    modal.on('hidden.bs.modal', this._onTimeLimitModalHidden);
  },
};
</script>
<style scoped>
.custom-btn {
    background: #E76229;
    color: white;
    padding: 0 30px !important;
    box-shadow: none !important;
}

.time-cont {
    border: 1px solid dimgrey;
    border-radius: 5px;
    font-size: 1.1rem;
    cursor: pointer;
    user-select: none;
}

.time-cont.active {
    color: white !important;
    background: dimgrey;
}

table {
        width: 100%;
        border-collapse: collapse;
        /* border-radius: 5px; */
        overflow: hidden;
        /* box-shadow: 0 0 20px rgba(0,0,0,0.1); */
    }

    th,
    td {
        padding: 10px !important;
        /* background-color: rgba(255,255,255,0.2); */
        /* color: #fff; */
        border: none !important;
        font-weight: 400 !important;
    }

    th {
        text-align: left;
    }

    thead {
        th {
            background: #E76229;
            color: white;
        }
    }

    tbody {
        color: #E76229;
        tr {
            &:hover {
                background-color: rgba(95, 111, 180, 0.3);
            }
        }
        td {
            position: relative;
            &:hover {
                &:before {
                    content: "";
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: -9999px;
                    bottom: -9999px;
                    /* background-color: rgba(255,255,255,0.2); */
                    z-index: -1;
                }
            }
        }
    }


.home-cards {
    padding-left: 10px;
    padding-right: 10px;
    width: 100%;
}

.bet-container {
    position: fixed;
    bottom: 0;
    margin-bottom: 5rem;
    width: 100px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0.25em;
    color: white;
    z-index: 100;
    visibility: visible;
    opacity: 1;
}
.main-image-wrapper img {
    width: 100%;
}
.video-container {
    height: 500px;
    width: 100%;
}
.notice-bar {
    margin-top: -40px;
    z-index: 1;
    /* color: white; */
    font-size: 20px;
    /* background: rgba(0, 0, 0, 0.5); */
    color: #172b4c;
    background: rgba(255, 242, 0, 0.7);
}
.twod-threed-cards {
    height: 200px;
}
.live-number {
    font-weight: bold;
    font-size: 25px;
    color: #E76229;
}
.live-result {
    font-weight: bolder;
    font-size: 60px;
    color: #E76229;
    animation-name: live-number-animation;
    animation-duration: 2s;
    animation-iteration-count: infinite;
}
.not-live-text {
    font-weight: bold;
    font-size: 24px;
}
.cards-container {
    display: flex;
    flex-wrap: wrap;
}
.card-body {
    padding: 0px !important;
}
.cards-container-mobile {
    display: none;
}
@keyframes live-number-animation {
    from {
        color: #E76229;
    }
    to {
        color: #F4F0E8;
    }
}

@media (max-width: 768px) {
    .video-container {
        height: 300px;
        width: 100%;
    }
    .main-wrapper {
        padding: 7px !important;
    }
    .notice-bar {
        margin-top: 0px;
        height: 30px;
        z-index: 1;
        font-size: 13px;
        color: #172b4c;
        background: rgba(255, 242, 0, 0.7);
    }
    .live-number {
        font-weight: bold;
        font-size: 15px;
    }
    .live-result {
        font-weight: bolder;
        font-size: 100px;
    }

    .cards-container {
        display: none;
    }
    .cards-container-mobile {
        padding: 0px !important;
        margin-top: 15px !important;
        display: flex;
        flex-wrap: wrap;
    }
    .home-cards {
        padding-left: 10px;
        padding-right: 10px;
    }
    .card-body {
        padding: 0px !important;
    }
    .not-live-text {
        font-size: 18px;
        padding-left: 10px;
        padding-right: 10px;
    }
}
</style>
